import React from 'react';
interface WebinarLinkProps {
  children: React.ReactNode;
  onClick: () => void;
}
export const WebinarLink: React.FC<WebinarLinkProps> = ({
  children,
  onClick
}) => {
  return <a href="https://stresslessdogs.nl/mcc-meta-adv2" className="text-blue-600 cursor-pointer hover:underline" target="_blank" rel="noopener noreferrer" data-id="element-408">
      {children}
    </a>;
};